import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { ChevronRight } from 'lucide-react';
export const TermsOfUsePage = () => {
  const lastUpdated = 'September 15, 2023';
  return <div className="min-h-screen flex flex-col" data-id="element-759">
      <Header data-id="element-760" />
      <main className="flex-grow pt-20" data-id="element-761">
        {/* Hero Banner */}
        <div className="bg-[#0a2351] text-white py-16" data-id="element-762">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-763">
            <h1 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-764">
              Terms of Use
            </h1>
            <p className="text-xl text-gray-200 max-w-2xl" data-id="element-765">
              Guidelines for using our website and services
            </p>
            <nav className="flex mt-6" aria-label="Breadcrumb" data-id="element-766">
              <ol className="inline-flex items-center space-x-1 md:space-x-3" data-id="element-767">
                <li className="inline-flex items-center" data-id="element-768">
                  <a href="/" className="text-gray-300 hover:text-white" data-id="element-769">
                    Home
                  </a>
                </li>
                <li data-id="element-770">
                  <div className="flex items-center" data-id="element-771">
                    <ChevronRight className="w-4 h-4 text-gray-300" data-id="element-772" />
                    <span className="ml-1 text-white md:ml-2" data-id="element-773">
                      Terms of Use
                    </span>
                  </div>
                </li>
              </ol>
            </nav>
          </div>
        </div>
        {/* Terms of Use Content */}
        <section className="py-12 bg-white" data-id="element-774">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-775">
            <div className="max-w-4xl mx-auto" data-id="element-776">
              <div className="bg-white rounded-lg shadow-sm p-8 mb-8" data-id="element-777">
                <div className="mb-8 text-sm text-gray-500" data-id="element-778">
                  Last Updated: {lastUpdated}
                </div>
                <h2 className="text-2xl font-bold mb-6 text-[#0a2351]" data-id="element-779">
                  Agreement to Terms
                </h2>
                <p className="mb-6 text-gray-700" data-id="element-780">
                  These Terms of Use constitute a legally binding agreement
                  between you and Sapis Capital Group ("Sapis," "we," "us," or
                  "our") regarding your access to and use of the website at
                  www.sapiscapital.com, as well as any other media form, media
                  channel, mobile website, or mobile application related or
                  connected thereto (collectively, the "Site").
                </p>
                <p className="mb-8 text-gray-700" data-id="element-781">
                  By accessing the Site, you agree to be bound by these Terms of
                  Use. If you do not agree to these Terms of Use, you must not
                  access or use the Site.
                </p>
                <h2 className="text-2xl font-bold mb-6 text-[#0a2351]" data-id="element-782">
                  Intellectual Property Rights
                </h2>
                <p className="mb-4 text-gray-700" data-id="element-783">
                  Unless otherwise indicated, the Site is our proprietary
                  property and all source code, databases, functionality,
                  software, website designs, audio, video, text, photographs,
                  and graphics on the Site (collectively, the "Content") and the
                  trademarks, service marks, and logos contained therein (the
                  "Marks") are owned or controlled by us or licensed to us, and
                  are protected by copyright and trademark laws and various
                  other intellectual property rights.
                </p>
                <p className="mb-8 text-gray-700" data-id="element-784">
                  The Content and Marks are provided on the Site "AS IS" for
                  your information and personal use only. Except as expressly
                  provided in these Terms of Use, no part of the Site and no
                  Content or Marks may be copied, reproduced, aggregated,
                  republished, uploaded, posted, publicly displayed, encoded,
                  translated, transmitted, distributed, sold, licensed, or
                  otherwise exploited for any commercial purpose whatsoever,
                  without our express prior written permission.
                </p>
                <h2 className="text-2xl font-bold mb-6 text-[#0a2351]" data-id="element-785">
                  User Representations
                </h2>
                <p className="mb-4 text-gray-700" data-id="element-786">
                  By using the Site, you represent and warrant that:
                </p>
                <ul className="list-disc pl-8 mb-8 text-gray-700" data-id="element-787">
                  <li className="mb-2" data-id="element-788">
                    You have the legal capacity and agree to comply with these
                    Terms of Use.
                  </li>
                  <li className="mb-2" data-id="element-789">
                    You are not a minor in the jurisdiction in which you reside.
                  </li>
                  <li className="mb-2" data-id="element-790">
                    You will not access the Site through automated or non-human
                    means.
                  </li>
                  <li className="mb-2" data-id="element-791">
                    You will not use the Site for any illegal or unauthorized
                    purpose.
                  </li>
                  <li className="mb-2" data-id="element-792">
                    Your use of the Site will not violate any applicable law or
                    regulation.
                  </li>
                </ul>
                <h2 className="text-2xl font-bold mb-6 text-[#0a2351]" data-id="element-793">
                  Prohibited Activities
                </h2>
                <p className="mb-4 text-gray-700" data-id="element-794">
                  You may not access or use the Site for any purpose other than
                  that for which we make the Site available. As a user of the
                  Site, you agree not to:
                </p>
                <ul className="list-disc pl-8 mb-8 text-gray-700" data-id="element-795">
                  <li className="mb-2" data-id="element-796">
                    Systematically retrieve data or other content from the Site
                    to create a collection, compilation, database, or directory.
                  </li>
                  <li className="mb-2" data-id="element-797">
                    Trick, defraud, or mislead us and other users, especially in
                    any attempt to learn sensitive account information.
                  </li>
                  <li className="mb-2" data-id="element-798">
                    Circumvent, disable, or otherwise interfere with
                    security-related features of the Site.
                  </li>
                  <li className="mb-2" data-id="element-799">
                    Use any information obtained from the Site to harass, abuse,
                    or harm another person.
                  </li>
                  <li className="mb-2" data-id="element-800">
                    Make improper use of our support services or submit false
                    reports of abuse or misconduct.
                  </li>
                  <li className="mb-2" data-id="element-801">
                    Use the Site in a manner inconsistent with any applicable
                    laws or regulations.
                  </li>
                  <li className="mb-2" data-id="element-802">
                    Engage in unauthorized framing of or linking to the Site.
                  </li>
                  <li className="mb-2" data-id="element-803">
                    Upload or transmit viruses, Trojan horses, or other material
                    that interferes with any party's uninterrupted use of the
                    Site.
                  </li>
                </ul>
                <h2 className="text-2xl font-bold mb-6 text-[#0a2351]" data-id="element-804">
                  Disclaimer
                </h2>
                <p className="mb-8 text-gray-700" data-id="element-805">
                  THE SITE IS PROVIDED ON AN "AS-IS" AND "AS AVAILABLE" BASIS.
                  YOU AGREE THAT YOUR USE OF THE SITE AND OUR SERVICES WILL BE
                  AT YOUR SOLE RISK. TO THE FULLEST EXTENT PERMITTED BY LAW, WE
                  DISCLAIM ALL WARRANTIES, EXPRESS OR IMPLIED, IN CONNECTION
                  WITH THE SITE AND YOUR USE THEREOF, INCLUDING, WITHOUT
                  LIMITATION, THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS
                  FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT.
                </p>
                <h2 className="text-2xl font-bold mb-6 text-[#0a2351]" data-id="element-806">
                  Limitation of Liability
                </h2>
                <p className="mb-8 text-gray-700" data-id="element-807">
                  IN NO EVENT WILL WE OR OUR DIRECTORS, EMPLOYEES, OR AGENTS BE
                  LIABLE TO YOU OR ANY THIRD PARTY FOR ANY DIRECT, INDIRECT,
                  CONSEQUENTIAL, EXEMPLARY, INCIDENTAL, SPECIAL, OR PUNITIVE
                  DAMAGES, INCLUDING LOST PROFIT, LOST REVENUE, LOSS OF DATA, OR
                  OTHER DAMAGES ARISING FROM YOUR USE OF THE SITE, EVEN IF WE
                  HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.
                </p>
                <h2 className="text-2xl font-bold mb-6 text-[#0a2351]" data-id="element-808">
                  Indemnification
                </h2>
                <p className="mb-8 text-gray-700" data-id="element-809">
                  You agree to defend, indemnify, and hold us harmless,
                  including our subsidiaries, affiliates, and all of our
                  respective officers, agents, partners, and employees, from and
                  against any loss, damage, liability, claim, or demand,
                  including reasonable attorneys' fees and expenses, made by any
                  third party due to or arising out of your use of the Site,
                  breach of these Terms of Use, or violation of any law or the
                  rights of a third party.
                </p>
                <h2 className="text-2xl font-bold mb-6 text-[#0a2351]" data-id="element-810">
                  Governing Law
                </h2>
                <p className="mb-8 text-gray-700" data-id="element-811">
                  These Terms of Use shall be governed by and defined following
                  the laws of the State of New York. Sapis Capital Group and
                  yourself irrevocably consent that the courts of New York shall
                  have exclusive jurisdiction to resolve any dispute which may
                  arise in connection with these Terms.
                </p>
                <h2 className="text-2xl font-bold mb-6 text-[#0a2351]" data-id="element-812">
                  Contact Us
                </h2>
                <p className="text-gray-700" data-id="element-813">
                  If you have any questions about these Terms of Use, please
                  contact us at:
                </p>
                <div className="mt-4 text-gray-700" data-id="element-814">
                  <p data-id="element-815">Sapis Capital Group</p>
                  <p data-id="element-816">123 Finance Street, Suite 500</p>
                  <p data-id="element-817">New York, NY 10001</p>
                  <p data-id="element-818">Email: legal@sapiscapital.com</p>
                  <p data-id="element-819">Phone: (212) 555-0123</p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer data-id="element-820" />
    </div>;
};